export default __webpack_public_path__ + "static/media/belgium.2bdeb95c.svg";